export { applyInputMapping } from './applyInputMapping'
